import React, { useState } from 'react';
import { MenuIcon, XIcon } from 'lucide-react';
import { motion } from 'framer-motion';
export function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };
  return <header className="fixed w-full bg-white shadow-sm z-50" data-id="element-137">
      <div className="container mx-auto px-4 py-4 flex justify-between items-center" data-id="element-138">
        <motion.a href="#" className="text-2xl font-bold text-gray-800" initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        duration: 0.5
      }} whileHover={{
        color: '#9333ea'
      }} data-id="element-139">
          Portfolio
        </motion.a>
        {/* Mobile menu button */}
        <motion.button className="md:hidden p-2 rounded-md text-gray-600 hover:text-gray-900 focus:outline-none" onClick={toggleMenu} aria-label="Toggle menu" whileHover={{
        scale: 1.1
      }} whileTap={{
        scale: 0.9
      }} data-id="element-140">
          {isMenuOpen ? <XIcon size={24} data-id="element-141" /> : <MenuIcon size={24} data-id="element-142" />}
        </motion.button>
        {/* Desktop navigation */}
        <motion.nav className="hidden md:flex space-x-8" initial={{
        opacity: 0,
        y: -10
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        delay: 0.2
      }} data-id="element-143">
          <motion.a href="#home" className="text-gray-600 hover:text-purple-600" whileHover={{
          scale: 1.1,
          color: '#9333ea'
        }} data-id="element-144">
            Home
          </motion.a>
          <motion.a href="#about" className="text-gray-600 hover:text-purple-600" whileHover={{
          scale: 1.1,
          color: '#9333ea'
        }} data-id="element-145">
            About
          </motion.a>
          <motion.a href="#skills" className="text-gray-600 hover:text-purple-600" whileHover={{
          scale: 1.1,
          color: '#9333ea'
        }} data-id="element-146">
            Skills
          </motion.a>
          <motion.a href="#projects" className="text-gray-600 hover:text-purple-600" whileHover={{
          scale: 1.1,
          color: '#9333ea'
        }} data-id="element-147">
            Projects
          </motion.a>
          <motion.a href="#contact" className="text-gray-600 hover:text-purple-600" whileHover={{
          scale: 1.1,
          color: '#9333ea'
        }} data-id="element-148">
            Contact
          </motion.a>
        </motion.nav>
      </div>
      {/* Mobile navigation */}
      {isMenuOpen && <motion.nav className="md:hidden bg-white px-4 py-2 shadow-md" initial={{
      opacity: 0,
      height: 0
    }} animate={{
      opacity: 1,
      height: 'auto'
    }} exit={{
      opacity: 0,
      height: 0
    }} transition={{
      duration: 0.3
    }} data-id="element-149">
          <div className="flex flex-col space-y-3 pb-3" data-id="element-150">
            <motion.a href="#home" className="text-gray-600 hover:text-purple-600 py-2" onClick={toggleMenu} whileHover={{
          x: 5,
          color: '#9333ea'
        }} data-id="element-151">
              Home
            </motion.a>
            <motion.a href="#about" className="text-gray-600 hover:text-purple-600 py-2" onClick={toggleMenu} whileHover={{
          x: 5,
          color: '#9333ea'
        }} data-id="element-152">
              About
            </motion.a>
            <motion.a href="#skills" className="text-gray-600 hover:text-purple-600 py-2" onClick={toggleMenu} whileHover={{
          x: 5,
          color: '#9333ea'
        }} data-id="element-153">
              Skills
            </motion.a>
            <motion.a href="#projects" className="text-gray-600 hover:text-purple-600 py-2" onClick={toggleMenu} whileHover={{
          x: 5,
          color: '#9333ea'
        }} data-id="element-154">
              Projects
            </motion.a>
            <motion.a href="#contact" className="text-gray-600 hover:text-purple-600 py-2" onClick={toggleMenu} whileHover={{
          x: 5,
          color: '#9333ea'
        }} data-id="element-155">
              Contact
            </motion.a>
          </div>
        </motion.nav>}
    </header>;
}